"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataTree = exports.getName = void 0;
var lodash_1 = __importDefault(require("lodash"));
var PRCUtils_1 = require("../data/PRCUtils");
var AbstractControl_1 = require("../data/control/AbstractControl");
function getName(key, cycles, departments, staffs, id) {
    if (key === 'cycle') {
        var cycle = lodash_1.default.find(cycles, { cycleNumber: id });
        if (cycle)
            return lodash_1.default.get(cycle, 'cycleName');
    }
    else if (key === 'category') {
        var ids = id.split('-');
        if (ids.length === 2) {
            var cycle = lodash_1.default.find(cycles, { cycleNumber: ids[0], categoryNumber: ids[1] });
            if (cycle)
                return lodash_1.default.get(cycle, 'categoryName');
        }
    }
    else if (key === 'subCategory') {
        var ids = id.split('-');
        if (ids.length === 3) {
            var cycle = lodash_1.default.find(cycles, {
                cycleNumber: ids[0],
                categoryNumber: ids[1],
                subCategoryNumber: ids[2]
            });
            if (cycle)
                return lodash_1.default.get(cycle, 'subCategoryName');
        }
    }
    else if (key === 'department') {
        var department = lodash_1.default.find(departments, { id: id });
        if (department)
            return lodash_1.default.get(department, 'departmentName');
    }
    else {
        var staff = lodash_1.default.find(staffs, { id: id });
        if (staff)
            return lodash_1.default.get(staff, 'name');
    }
    return id;
}
exports.getName = getName;
function getDataTreeInner(keyPrefix, keys, data, cycles, departments, staffs) {
    if (lodash_1.default.isEmpty(keys)) {
        return data.map(function (value, i) {
            return {
                type: value.type,
                key: keyPrefix + i + '/' + value.id,
                id: value.id,
                title: value.name,
                keyControl: (0, PRCUtils_1.isControl)(value) ? value.keyControl === AbstractControl_1.YesNo.yes : undefined
            };
        });
    }
    var target = keys[0];
    return (0, lodash_1.default)(data)
        .groupBy(function (element) {
        // const base = element as BasePRC
        if (target === 'cycle') {
            return element.cycleNumber;
        }
        else if (target === 'category') {
            return element.cycleNumber + '-' + element.categoryNumber;
        }
        else if (target === 'subCategory') {
            return element.cycleNumber + '-' + element.categoryNumber + '-' + element.subCategoryNumber;
        }
        else if (target === 'department') {
            // Control
            return lodash_1.default.get(element, 'department');
        }
        else if (target === 'owner') {
            // Control
            return lodash_1.default.get(element, 'owner');
        }
        else if (target === 'performer') {
            // Control
            return lodash_1.default.get(element, 'performer');
        }
    })
        .map(function (values, key) {
        var name = getName(target, cycles, departments, staffs, key);
        return {
            key: keyPrefix + '-' + key,
            type: target,
            id: key,
            title: name || key,
            children: getDataTreeInner(keyPrefix + '-' + key, lodash_1.default.drop(keys), values, cycles, departments, staffs)
        };
    })
        .value();
}
function compareIds(a, b) {
    var c = lodash_1.default.toNumber(a);
    var d = lodash_1.default.toNumber(b);
    if (lodash_1.default.isNaN(c) || lodash_1.default.isNaN(d)) {
        return a.localeCompare(b);
    }
    return c - d;
}
function sortNodeByIds(items) {
    items.sort(function (a, b) {
        if (!lodash_1.default.isNaN(lodash_1.default.toNumber(a.id)) && !lodash_1.default.isNaN(lodash_1.default.toNumber(b.id))) {
            return lodash_1.default.toNumber(a.id) - lodash_1.default.toNumber(b.id);
        }
        var aKeys = a.id.split('-');
        var bKeys = b.id.split('-');
        for (var i = 0; i < aKeys.length && i < bKeys.length; ++i) {
            var diff = compareIds(aKeys[i], bKeys[i]);
            if (!lodash_1.default.isNaN(diff) && diff !== 0) {
                return diff;
            }
        }
        return 0;
    });
}
function getDataTree(keys, data, cycles, departments, staffs) {
    if (lodash_1.default.isEmpty(data))
        return [];
    var keyList = lodash_1.default.compact(keys.map(function (key) {
        if (key === 'cycle-cycle') {
            return 'cycle';
        }
        else if (key === 'cycle-category') {
            // NOTE: 소분류가 없는 경우, key가 cycle-분류로 입력
            return 'category';
        }
        else if (key === 'cycle-subCategory') {
            return 'subCategory';
        }
        else if (key === 'worker-department') {
            return 'department';
        }
        else if (key === 'worker-owner') {
            return 'owner';
        }
        else if (key === 'worker-performer') {
            return 'performer';
        }
        return undefined;
    }));
    var items = getDataTreeInner('root', keyList, data, cycles, departments, staffs);
    sortNodeByIds(items);
    return items;
}
exports.getDataTree = getDataTree;
//# sourceMappingURL=Tree.js.map